import { PasswordRuleResult } from 'src/app/models/passwordPolicy.model';
import { PASSWORD_MIN_LENGTH, PASSWORD_RULE_LABELS } from '../constants/passwordPolicy.constants';

export function evaluatePasswordRules(password: string): PasswordRuleResult[] {
    return [
        { label: PASSWORD_RULE_LABELS.minLength, params: { count: PASSWORD_MIN_LENGTH }, met: password.length >= PASSWORD_MIN_LENGTH },
        { label: PASSWORD_RULE_LABELS.uppercase, met: /[A-Z]/.test(password) },
        { label: PASSWORD_RULE_LABELS.lowercase, met: /[a-z]/.test(password) },
        { label: PASSWORD_RULE_LABELS.digit, met: /[0-9]/.test(password) },
        { label: PASSWORD_RULE_LABELS.special, met: /[^A-Za-z0-9]/.test(password) },
    ];
}

export function meetsPasswordPolicy(password: string): boolean {
    return evaluatePasswordRules(password).every((rule) => rule.met);
}
